/* tslint:disable */
/* eslint-disable */
/**
 * FancyAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const GetV3StudentsPresenceEventsR200ResponseInnerDetailsOneOfContentsPracticeModeEnum = {
    MathAdaptivePractice: 'math_adaptive_practice',
    MathTargetedPractice: 'math_targeted_practice',
    MathBenchmarkAssessments: 'math_benchmark_assessments',
    MathFactPractice: 'math_fact_practice',
    MathNumberBasics: 'math_number_basics',
    MathNumberFacts: 'math_number_facts',
    MathDepthOfKnowledgePractice: 'math_depth_of_knowledge_practice',
    MathInquiryBasedLessons: 'math_inquiry_based_lessons',
    FocusSkillsPractice: 'focus_skills_practice',
    ElaSkillsPractice: 'ela_skills_practice',
    ElaReading: 'ela_reading',
    ElaWriting: 'ela_writing',
    ElaBenchmarkAssessments: 'ela_benchmark_assessments',
    ElaDecodables: 'ela_decodables',
    ElaWordStudy: 'ela_word_study',
    ElaSightWords: 'ela_sight_words',
    ElaFocusSkillsPractice: 'ela_focus_skills_practice',
    ScienceReading: 'science_reading',
    ScienceWriting: 'science_writing',
    SocialStudiesReading: 'social_studies_reading',
    SocialStudiesWriting: 'social_studies_writing'
};
/**
 * Check if a given object implements the GetV3StudentsPresenceEventsR200ResponseInnerDetailsOneOfContents interface.
 */
export function instanceOfGetV3StudentsPresenceEventsR200ResponseInnerDetailsOneOfContents(value) {
    if (!('practiceMode' in value) || value['practiceMode'] === undefined)
        return false;
    return true;
}
export function GetV3StudentsPresenceEventsR200ResponseInnerDetailsOneOfContentsFromJSON(json) {
    return GetV3StudentsPresenceEventsR200ResponseInnerDetailsOneOfContentsFromJSONTyped(json, false);
}
export function GetV3StudentsPresenceEventsR200ResponseInnerDetailsOneOfContentsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'practiceMode': json['practiceMode'],
    };
}
export function GetV3StudentsPresenceEventsR200ResponseInnerDetailsOneOfContentsToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'practiceMode': value['practiceMode'],
    };
}
